import React from "react";
import { Layout } from "@/components/Layout";
import { DOCS } from "@/data/mock";
import { cn } from "@/lib/utils";

export default function Docs() {
  const [active, setActive] = React.useState(DOCS[0].id);
  const refs = React.useRef({});

  const scrollTo = (id) => {
    setActive(id);
    refs.current[id]?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Layout>
      <div className="mx-auto max-w-[1400px] px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8">
          <span className="label-accent">Documentation</span>
          <h1 className="mt-2 font-heading text-4xl font-extrabold tracking-tight">CLAWNET Docs</h1>
        </div>
        <div className="flex gap-10">
          <aside className="hidden w-60 shrink-0 lg:block">
            <nav className="sticky top-24 space-y-0.5">
              {DOCS.map((d) => (
                <button key={d.id} onClick={() => scrollTo(d.id)} data-testid={`docs-nav-${d.id}`}
                  className={cn("block w-full rounded-lg px-3 py-2 text-left text-sm transition-colors",
                    active === d.id ? "bg-cyan-400/10 font-semibold text-cyan-200" : "text-slate-400 hover:bg-white/5 hover:text-white")}>
                  {d.title}
                </button>
              ))}
            </nav>
          </aside>

          <div className="min-w-0 flex-1">
            <div className="lg:hidden">
              <div className="no-scrollbar mb-6 flex gap-2 overflow-x-auto">
                {DOCS.map((d) => (
                  <button key={d.id} onClick={() => scrollTo(d.id)}
                    className="shrink-0 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-semibold text-slate-300">
                    {d.title}
                  </button>
                ))}
              </div>
            </div>
            <div className="max-w-2xl space-y-10">
              {DOCS.map((d) => (
                <section key={d.id} id={d.id} ref={(el) => (refs.current[d.id] = el)} className="scroll-mt-24" data-testid={`docs-section-${d.id}`}>
                  <h2 className="font-heading text-2xl font-bold text-white">{d.title}</h2>
                  <p className="mt-3 leading-relaxed text-slate-300">{d.body}</p>
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
